import { render, staticRenderFns } from "./supplierListView.vue?vue&type=template&id=132d86fe&scoped=true"
import script from "./supplierListView.vue?vue&type=script&lang=js"
export * from "./supplierListView.vue?vue&type=script&lang=js"
import style0 from "./supplierListView.vue?vue&type=style&index=0&id=132d86fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d86fe",
  null
  
)

export default component.exports